var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10px",
    height: "13px",
    viewBox: "0 0 10 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Arrow") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "square"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Team/1440",
    transform: "translate(-834.000000, -1081.000000)",
    stroke: "#000000",
    strokeWidth: 1.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(140.000000, 512.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Btn",
    transform: "translate(680.000000, 556.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Arrow",
    transform: "translate(15.480661, 14.519339)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: -0.968735548,
    y1: 4.49573055,
    x2: 8.0312604,
    y2: 4.50426945,
    id: "Line",
    transform: "translate(3.531264, 4.500000) scale(-1, 1) rotate(-90.000000) translate(-3.531264, -4.500000) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.53553391,
    y1: 10.0323891,
    x2: 7.07106781,
    y2: 6.49685516,
    id: "Line",
    transform: "translate(5.303301, 8.264622) scale(-1, 1) rotate(-90.000000) translate(-5.303301, -8.264622) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: -3.62848903e-17,
    y1: 10.0323891,
    x2: 3.53553391,
    y2: 6.49685516,
    id: "Line",
    transform: "translate(1.767767, 8.264622) scale(-1, -1) rotate(90.000000) translate(-1.767767, -8.264622) "
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.1b20a08aa0e6edb507af15d726ca060a.svg";
export { ForwardRef as ReactComponent };